import { Modal, ModalHeader, ModalBody } from "react-bootstrap";
import { useJsApiLoader, StandaloneSearchBox } from "@react-google-maps/api";
import { GeolocationApiKey } from "../../../utlis/common.utlis";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../utlis/user/routes.utlis";
import Map from "../../../assets/user/images/Google_Map.svg";
import Search from "../../../assets/user/images/search-normal.svg";

// Define libraries array outside the component
const GOOGLE_MAP_LIBRARIES = ["places"];

function FindJobModal({ show, onHide, inputRef, location, setLocation }) {
    const navigate = useNavigate();

    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: GeolocationApiKey,
        libraries: GOOGLE_MAP_LIBRARIES, // Use the static array here
    });

    function findStateCity(type, arr) {
        for (let i in arr) {
            if (arr[i].types.includes(type)) {
                return arr[i].long_name;
            }
        }
        return null;
    }

    const handlePlaceChange = () => {
        let [address] = inputRef.current.getPlaces();
        setLocation({
            lat: address.geometry.location.lat(),
            lng: address.geometry.location.lng(),
            address: address.formatted_address,
            state: findStateCity(
                "administrative_area_level_1",
                address.address_components
            ),
        });
    };

    return (
        <Modal show={show} onHide={onHide} className="">
            <div className="modal-content">
                <ModalHeader>Find A Job</ModalHeader>
                <ModalBody className="">
                    <div className="add-items d-flex row">
                        <div className="col-md-9">
                            <div className="form-group">
                                {isLoaded && (
                                    <StandaloneSearchBox
                                        onLoad={(ref) => (inputRef.current = ref)}
                                        onPlacesChanged={handlePlaceChange}
                                    >
                                        <input
                                            className="form-control ps-5"
                                            placeholder="Enter Job Location"
                                            defaultValue={location.address}
                                        />
                                    </StandaloneSearchBox>
                                )}
                                <span className="search-lo-icon">
                                    &nbsp; &nbsp; <img src={Map} alt="" />
                                </span>
                            </div>
                        </div>
                        <div className="col-md-1">
                            <button
                                className="intake-btn-done"
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigate(routes.careNetwork, {
                                        state: {
                                            lat: location.lat,
                                            lng: location.lng,
                                            address: location.address,
                                        },
                                    });
                                }}
                            >
                                <img src={Search} alt="" />
                            </button>
                        </div>
                    </div>
                </ModalBody>
            </div >
        </Modal >
    );
}

export default FindJobModal;